"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleVarnishes = void 0;
const helper_functions_1 = require("../../helper-functions");
exports.vehicleVarnishes = [
    {
        id: (0, helper_functions_1.generateUUID)(),
        hexCode: '#FFFFFF',
        name: 'white',
        varnishType: 'Metallic',
        additionalPrice: 0,
    },
    {
        id: (0, helper_functions_1.generateUUID)(),
        hexCode: '#c4c4c4',
        name: 'gray',
        varnishType: 'Metallic',
        additionalPrice: 5000,
    },
    {
        id: (0, helper_functions_1.generateUUID)(),
        hexCode: '#4dada8',
        name: 'turquoise',
        varnishType: 'Metallic',
        additionalPrice: 3500,
    },
    {
        id: (0, helper_functions_1.generateUUID)(),
        hexCode: '#2f326b',
        name: 'darkblue',
        varnishType: 'Metallic',
        additionalPrice: 1337,
    },
    {
        id: (0, helper_functions_1.generateUUID)(),
        hexCode: '#F2CC66',
        name: 'yellow',
        varnishType: 'Metallic',
        additionalPrice: 2499,
    },
];
//# sourceMappingURL=vehicleVarnishes.js.map